import Vue from "vue";
import Vuex from "vuex";
import i18n from "@/common/multilanguage/i18n";
import { trackEvent } from "@/common/functions";
import ThesaurusFilterModule from "./modules/ThesaurusFilterModule";
import LoginModule from "./modules/LoginModule";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        /** The current language locale, based on route. */
        currentLanguage: i18n.locale,
        /** AB experimentation data */
        experiments: {
            /**
             * String value for the experiment channel. Valid values: 'A','B','C','D'
             */
            channel: null,
            /**
             * Override value for the experiment channel. Used for per-page overrides. Valid values same as above.
             */
            overrideChannel: null,
            /**
             * The date version string for the channel. Format: 'YYMMDD'
             */
            date: null
        }
    },
    actions: {
        /** Track a Google Event. */
        trackEvent: function(context, payload) {
            const {
                ga,
                eventCategory,
                eventAction,
                eventLabel,
                eventValue,
                disableABTest
            } = payload;
            const eventData = {
                eventCategory,
                eventAction,
                eventLabel,
                eventValue
            };

            if (!disableABTest) {
                const expChannel = context.getters.getExperimentChannel;
                const expDate = context.getters.getExperimentDate;

                if (expChannel && expDate) {
                    eventData.dimension2 = `v_${expChannel}`;
                }
            }

            trackEvent(ga, eventData);
        }
    },
    mutations: {
        setCurrentLanguage: (state, language) => (state.currentLanguage = language),
        loadExperiments: function(state, data) {
            if (data.channel) state.experiments.channel = data.channel;
            if (data.date) state.experiments.date = data.date;
            if (data.overrideChannel) state.experiments.overrideChannel = data.overrideChannel;
        },
        updateLastVisited: function(state, value) {
            state.lastVisited = value;
        }
    },
    getters: {
        currentLanguage: state => state.currentLanguage,
        getExperimentChannel: state => {
            if (state.experiments.overrideChannel) {
                return state.experiments.overrideChannel;
            }
            return state.experiments.channel;
        },
        getExperimentDate: state => state.experiments.date,
        getExperimentChannelA: (state, getters) => getters.getExperimentChannel === "A"
    },
    modules: {
        thesaurusFilter: ThesaurusFilterModule,
        login: LoginModule
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js